<template>
  <div class="freight-page">
    <a-card title="快递运费模板" :loading="loading">
      <a-alert class="freight-tip" type="info" show-icon message="客户结算时选择快递；基础重量内收取基准价格，超出部分按整公斤向上取整收取续重费；命中省份特殊规则时仅替换基准价格。" />
      <div class="global-setting">
        <span>全场满额包邮</span><a-input-number v-model="setting.freeShippingAmount" :min="0" :precision="3" />
        <span>元（0 表示不启用）</span><a-button type="primary" :loading="savingSetting" @click="saveGlobalSetting">保存</a-button>
      </div>
      <div class="company-toolbar"><h3>快递分类</h3><a-button type="primary" icon="plus" @click="openEditor()">添加快递</a-button></div>
      <a-table row-key="id" :columns="columns" :data-source="companies" :pagination="false">
        <template slot="default" slot-scope="text, record"><a-tag :color="record.isDefault === 1 ? 'green' : 'default'">{{ record.isDefault === 1 ? '默认' : '普通' }}</a-tag></template>
        <template slot="status" slot-scope="text"><a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '启用' : '停用' }}</a-tag></template>
        <template slot="rules" slot-scope="text">{{ ruleSummary(text) }}</template>
        <template slot="action" slot-scope="text, record">
          <a @click="openEditor(record)">编辑</a><a-divider type="vertical" />
          <a-popconfirm title="确认删除该快递？" @confirm="removeCompany(record)"><a class="danger-link">删除</a></a-popconfirm>
        </template>
      </a-table>
    </a-card>

    <a-modal v-model="visible" :title="form.id ? '编辑快递' : '添加快递'" :width="860" :confirm-loading="savingCompany" @ok="saveCompany">
      <a-form-model :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-form-model-item label="快递名称"><a-input v-model.trim="form.name" maxlength="80" placeholder="例如：顺丰速运" /></a-form-model-item>
        <a-form-model-item label="快递编码"><a-input v-model.trim="form.code" maxlength="40" placeholder="例如：SF" /></a-form-model-item>
        <a-form-model-item label="基准价格"><a-input-number v-model="form.baseFee" :min="0" :precision="3" /><span class="unit-text">元</span></a-form-model-item>
        <a-form-model-item label="基础重量"><a-input-number v-model="form.baseWeightKg" :min="0.001" :precision="3" /><span class="unit-text">kg</span></a-form-model-item>
        <a-form-model-item label="每公斤续重费"><a-input-number v-model="form.additionalFeePerKg" :min="0" :precision="3" /><span class="unit-text">元/kg</span></a-form-model-item>
        <a-form-model-item label="状态"><a-switch :checked="form.status === 1" checked-children="启用" un-checked-children="停用" @change="form.status = $event ? 1 : 0" /></a-form-model-item>
        <a-form-model-item label="默认快递"><a-switch :checked="form.isDefault === 1" checked-children="是" un-checked-children="否" @change="form.isDefault = $event ? 1 : 0" /></a-form-model-item>
        <a-form-model-item label="排序"><a-input-number v-model="form.sortOrder" :min="0" :precision="0" /></a-form-model-item>
        <a-form-model-item label="省份特殊规则">
          <div v-for="(rule, index) in rules" :key="index" class="rule-row">
            <a-select v-model="rule.provinces" mode="multiple" placeholder="选择省份" class="province-select">
              <a-select-option v-for="province in provinces" :key="province" :value="province">{{ province }}</a-select-option>
            </a-select>
            <a-input-number v-model="rule.fee" :min="0" :precision="3" placeholder="特殊价格" /><span>元</span>
            <a-button icon="delete" @click="rules.splice(index, 1)">删除</a-button>
          </div>
          <a-button icon="plus" @click="rules.push({ provinces: [], fee: 0 })">添加省份规则</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { deleteFreightCompany, getFreightCompanies, getFreightSetting, saveFreightCompany, saveFreightSetting } from '@/api'

export default {
  data() {
    return {
      loading: false, savingSetting: false, savingCompany: false, visible: false,
      setting: { id: 1, freeShippingAmount: 0, defaultFee: 0, specialRules: '[]' }, companies: [], form: {}, rules: [],
      provinces: ['北京','天津','河北','山西','内蒙古','辽宁','吉林','黑龙江','上海','江苏','浙江','安徽','福建','江西','山东','河南','湖北','湖南','广东','广西','海南','重庆','四川','贵州','云南','西藏','陕西','甘肃','青海','宁夏','新疆'],
      columns: [
        { title: '快递名称', dataIndex: 'name' }, { title: '编码', dataIndex: 'code' }, { title: '基准价格', dataIndex: 'baseFee' },
        { title: '基础重量(kg)', dataIndex: 'baseWeightKg' }, { title: '续重费(元/kg)', dataIndex: 'additionalFeePerKg' },
        { title: '省份特殊规则', dataIndex: 'specialRules', scopedSlots: { customRender: 'rules' } },
        { title: '默认选项', key: 'default', scopedSlots: { customRender: 'default' } },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' } },
        { title: '操作', key: 'action', width: 140, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      Promise.all([getFreightSetting(), getFreightCompanies()]).then(([settingRes, companyRes]) => {
        this.setting = { id: 1, freeShippingAmount: Number((settingRes.data || {}).freeShippingAmount || 0), defaultFee: 0, specialRules: '[]' }
        this.companies = companyRes.data || []
      }).finally(() => { this.loading = false })
    },
    parseRules(value) { try { const rows = JSON.parse(value || '[]'); return Array.isArray(rows) ? rows : [] } catch (e) { return [] } },
    ruleSummary(value) { const rows = this.parseRules(value); return rows.length ? `${rows.length} 条规则` : '按基准价格' },
    openEditor(record) {
      this.form = record ? { ...record } : { name: '', code: '', baseFee: 0, baseWeightKg: 1, additionalFeePerKg: 0, status: 1, isDefault: this.companies.length ? 0 : 1, sortOrder: this.companies.length }
      this.rules = this.parseRules(this.form.specialRules).map(item => ({ provinces: item.provinces || [], fee: Number(item.fee || 0) }))
      this.visible = true
    },
    saveGlobalSetting() {
      this.savingSetting = true
      saveFreightSetting(this.setting).then(() => this.$message.success('满额包邮设置已保存')).finally(() => { this.savingSetting = false })
    },
    saveCompany() {
      if (!this.form.name || !this.form.code) return this.$message.warning('请填写快递名称和微信物流编码')
      if (!(Number(this.form.baseWeightKg) > 0)) return this.$message.warning('基础重量必须大于0')
      if (Number(this.form.additionalFeePerKg) < 0) return this.$message.warning('每公斤续重费不能小于0')
      if (this.rules.some(item => !item.provinces.length)) return this.$message.warning('请选择特殊规则对应的省份')
      this.savingCompany = true
      saveFreightCompany({ ...this.form, specialRules: JSON.stringify(this.rules) }).then(() => {
        this.$message.success('快递模板已保存'); this.visible = false; this.loadData()
      }).finally(() => { this.savingCompany = false })
    },
    removeCompany(record) { deleteFreightCompany({ id: record.id }).then(() => { this.$message.success('快递已删除'); this.loadData() }) }
  }
}
</script>

<style scoped>
.freight-page{padding:20px;background:#fff}.freight-tip{margin-bottom:24px}.global-setting{margin-bottom:28px;display:flex;align-items:center;gap:10px}.company-toolbar{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px}.company-toolbar h3{margin:0}.rule-row{margin-bottom:10px;display:flex;align-items:center;gap:8px}.province-select{width:430px}.unit-text{margin-left:8px}.danger-link{color:#f5222d}
</style>
